import firebase from 'firebase';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs } from 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyDUjzwuUU7SdfgCtvj0ukWhI2HBq2Jyz5U',
  authDomain: 'ivanooo.firebaseapp.com',
  databaseURL: 'https://ivanooo-default-rtdb.firebaseio.com',
  projectId: 'ivanooo',
  storageBucket: 'ivanooo.appspot.com',
  messagingSenderId: '674732140680'
}; 

firebase.initializeApp(config);

export default firebase;
const constDatabaseRef=firebase.database().ref();
export const insightRef=constDatabaseRef.child('insights')
export const courseRef=constDatabaseRef.child('Course')
export const secUser=constDatabaseRef.child('SecUser')
export const guidance=constDatabaseRef.child('Guidance')
export const testimonialRef=constDatabaseRef.child('testimonials')
export const storyRef=constDatabaseRef.child('stories')
export const expertiseRef=constDatabaseRef.child('expertise')
export const skillsRef=constDatabaseRef.child('skills')
export const educationRef=constDatabaseRef.child('education')
export const experienceRef=constDatabaseRef.child('experience')
export const priceRangeRef=constDatabaseRef.child('priceRange')
export const personnaRef=constDatabaseRef.child('personna')
export const goalsRef=constDatabaseRef.child('goals')
export const countryRef=constDatabaseRef.child('country')
export const modeOfLearningRef=constDatabaseRef.child('modeOfLearning')
export const institutionRef=constDatabaseRef.child('institution')
export const storyCategoryRef=constDatabaseRef.child('storyCategory')
export const database = firebase.database();

// export const auth = firebase.auth();
 export const storage = firebase.storage();
 export const db = firebase.firestore();

// export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
// export const messaging = firebase.messaging();


// WEBPACK FOOTER //
// ./src/firebase.js